import bean_animation from 'public/animations/bean_animation.json'
import lentill_animation from 'public/animations/lentill_animation.json'
import pearmillet_animation from 'public/animations/pearmillet_animation.json'
import peas_animation from 'public/animations/peas_animation.json'
import shorgum_animation from 'public/animations/shorgum_animation.json'

export const getAnimationBySlug = (slug: string) => {
  switch (slug) {
    case 'bean':
      return bean_animation
    case 'lentils':
      return lentill_animation
    case 'pearl-millet':
      return pearmillet_animation
    case 'peas':
      return peas_animation
    case 'sorghum':
      return shorgum_animation
    default:
      return bean_animation
  }
}
